module.exports = __webpack_public_path__ + "img/sixpackcarrier104.d42585c0.jpg";